// Validadores para datos chilenos: RUT (módulo 11) y Patente.

export function cleanRut(rut = "") {
  return rut.replace(/[^0-9kK]/g, "").toUpperCase();
}

export function formatRut(rut = "") {
  const cleaned = cleanRut(rut);
  if (cleaned.length < 2) return cleaned;
  const body = cleaned.slice(0, -1);
  const dv = cleaned.slice(-1);
  const withDots = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${withDots}-${dv}`;
}

export function validateRut(rut = "") {
  const cleaned = cleanRut(rut);
  if (cleaned.length < 2) return false;
  const body = cleaned.slice(0, -1);
  const dv = cleaned.slice(-1);
  if (!/^\d+$/.test(body)) return false;
  let sum = 0;
  let factor = 2;
  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body[i], 10) * factor;
    factor = factor === 7 ? 2 : factor + 1;
  }
  const remainder = 11 - (sum % 11);
  const expected = remainder === 11 ? "0" : remainder === 10 ? "K" : String(remainder);
  return expected === dv;
}

export function cleanPatente(patente = "") {
  return patente.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
}

// Formatea la patente: máximo 6 caracteres y los 2 primeros siempre letras.
export function formatPatente(value = "") {
  const c = cleanPatente(value);
  let letters = "";
  let rest = "";
  for (const ch of c) {
    if (letters.length < 2) {
      if (/[A-Z]/.test(ch)) letters += ch; // ignora dígitos hasta tener 2 letras
    } else if (rest.length < 4) {
      rest += ch;
    }
  }
  return letters + rest;
}

export function validatePatente(patente = "") {
  const c = cleanPatente(patente);
  return (
    /^[A-Z]{2}\d{4}$/.test(c) || // autos antiguos
    /^[A-Z]{4}\d{2}$/.test(c) || // autos nuevos
    /^[A-Z]{3}\d{2}$/.test(c) // motos / otros
  );
}

export function validateEmail(email = "") {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

export function validateCelular(celular = "") {
  const digits = celular.replace(/\D/g, "");
  return digits.length >= 8;
}

export function validateFechaNacimiento(fecha = "") {
  if (!fecha) return false;
  const d = new Date(fecha);
  if (Number.isNaN(d.getTime())) return false;
  const today = new Date();
  if (d >= today) return false;
  let age = today.getFullYear() - d.getFullYear();
  const m = today.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age--;
  return age >= 18 && age <= 99;
}
